class Store {
    constructor() {
        this.state = {
            loaded: false,
            freeze: false
        }
    }
}

let store = new Store();
export default store;


// WEBPACK FOOTER //
// ./src/store/Store.js